import {Dispatch, FC} from 'react';
import Modal from 'react-modal';
import {Button} from '../Button';
import {generalPopupStyles} from '../../../constants/popupStyles';
import Spinner from '../Spinner';

const defaultTitle = 'Please confirm your action.';
const cancelLabel = 'Cancel';
const confirmLabel = 'Confirm';

Modal.setAppElement(document.getElementById('root'));

interface ConfirmationPopupProps {
  labels: {
    title?: string,
    body: string,
    confirmBtn?: string,
    cancelBtn?: string,
  };
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  confirmableAction: () => void;
  isActionProcessing?: boolean;
  noCancel?: boolean;
}

const ConfirmationPopup: FC<ConfirmationPopupProps> = ({
  labels,
  isOpen,
  setIsOpen,
  confirmableAction,
  isActionProcessing,
  noCancel
}) => {
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={generalPopupStyles}
      contentLabel="Confirmation Popup"
      shouldCloseOnOverlayClick={!isActionProcessing}
    >
      {isActionProcessing ? <Spinner/> : (
        <div className="confirmation-popup">
          <h4 className="title">{labels.title || defaultTitle}</h4>
          <p className="body">{labels.body}</p>
          <div className="buttons">
            <Button
              label={labels.confirmBtn || confirmLabel}
              disabled={isActionProcessing}
              onClick={confirmableAction}
            />

            {noCancel || (
              <Button
                label={labels.cancelBtn || cancelLabel}
                variant="text"
                onClick={closeModal}
              />
            )}
          </div>
        </div>
      )}
    </Modal>);
};

export default ConfirmationPopup;
